// define a few global variables
var map;
var dynamicIndexLayer;
var identifiedFeatures = [];

// initialise the map
tasmapInitMap();

function tasmapInitMap() {
  let mbAttr = 'Map data &copy; <a href="https://www.tas.gov.au/stds/codi.htm">Government of Tasmania</a>';
  let topogUrl = 'https://services.thelist.tas.gov.au/arcgis/rest/services/Basemaps/Topographic/MapServer/tile/{z}/{y}/{x}';
  let imageUrl = 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
  let indexUrl = 'https://services.thelist.tas.gov.au/arcgis/rest/services/Public/Indexes/MapServer';

  let topogBase = L.tileLayer(topogUrl, {maxZoom: 25, attribution: mbAttr});
  let imageBase = L.tileLayer(imageUrl, {maxZoom: 25, attribution: mbAttr});

  let bound1 = L.latLng(-39.450, 142.850);
  let bound2 = L.latLng(-44.100, 149.480);

  let k25 = L.esri.dynamicMapLayer({url: indexUrl, layers: [0]});
  let k50 = L.esri.dynamicMapLayer({url:indexUrl, layers: [65]});
  let k100 = L.esri.dynamicMapLayer({url:indexUrl, layers: [1]});
  let k250 = L.esri.dynamicMapLayer({url:indexUrl, layers: [2]});
  let natpark = L.esri.dynamicMapLayer({url:indexUrl, layers: [4]});
  
  map = L.map('map', {
      center: [-41.837, 146.574],
      zoom: 7,
      minZoom: 7,
      zoomDelta: 0.5,
      zoomSnap: 0.5,
      maxBounds: [bound1, bound2],
      zoomControl: false,
      layers: [topogBase]
  });

  // Initialise Zoom and Home controls
  let zoomhome = new L.Control.ZoomHome({
    position: 'topleft',
    zoomHomeTitle: 'Reset Zoom'
  }).addTo(map);
  
  // Initialise scale bar (this is a control extension)
  let graphicscale = L.control.graphicScale({
    fill: 'fill',
    maxUnitsWidth: 180,
    labelPlacement: 'top'
  }).addTo(map);
  
  let baseLayers = {
      'Topography': topogBase,
      'Imagery': imageBase
  };

  let overlays = {
      'National Parks': natpark,
      '1:25 000': k25,
      '1:50 000': k50,
      '1:100 000': k100,
      '1:250 000': k250
  };

  let layerControl = L.control.layers(baseLayers, overlays).addTo(map);

  dynamicIndexLayer = L.esri.dynamicMapLayer({
      url: 'https://services.thelist.tas.gov.au/arcgis/rest/services/Public/Indexes/MapServer',
      layers: [0, 65, 1, 2, 4],
      opacity: 1
  });

  map.on('click', function(e) { console.log('Tasmap Click'); tasmapOnMapClick (e)});
}

function tasmapOnMapClick(e) {
  // declare variables
  let tasmapTableBody = document.getElementById('tasmap-selected-maps');

  // initialise variables and clear features
  tasmapTableBody.innerHTML = "<tr class='blank_row'><td>Loading...</td></tr>";
  tasmapRemoveFeatures();
  identifiedFeatures.length = 0;

  dynamicIndexLayer
    .identify()
    .layers('visible:0,65,1,2,4')
    .on(map)
    .at(e.latlng)
    .run(function (error, featureCollection) {
      if (error) {
        return;
      }

      // make sure at least one feature was identified.
      if (featureCollection.features.length > 0) {
          tasmapTableBody.innerHTML = "<thead><tr class='blank_row'><td colspan=2>&nbsp;</td></tr></thead>";
          tasmapTableBody.innerHTML += "<tr class='header_row'><th>Map Name</th><th>Map Scale</th></tr>";
          for (i = 0; i < featureCollection.features.length; i++) {
                identifiedFeatures.push(L.geoJSON(featureCollection.features[i]));
                let mapNumber = featureCollection.features[i].properties['Map Number'];
                let mapName = titleCase(featureCollection.features[i].properties['Map Name']);
                let mapScale = featureCollection.features[i].properties['Scale'];
                let mapPage = "https://tasmaps.myshopify.com/products/" + mapNumber;
                if (!mapScale) {
                  mapScale = "?";
                } else {
                  mapScale = "1:" + numberWithCommas(mapScale);
                }
                tasmapTableBody.innerHTML +=
                  "<tr onmouseover='tasmapLocateFeature(" + i + ")'>" +
                    "<td><a class='product-link' onclick='tasmapShowMap(&quot;" + mapPage + "&quot;)'>" + mapName + "</a></td>" +
                    "<td>" + mapScale + "</td>" +
                  "</tr>";
          }
      } else {
        tasmapTableBody.innerHTML = "<tr class='blank_row'><td>No maps found in the selected area of interest</td></tr>";
      }
    });
}

function tasmapLocateFeature(i) {
  tasmapRemoveFeatures();
  identifiedFeatures[i].addTo(map);
}

function tasmapRemoveFeatures() {
  for (i = 0; i < identifiedFeatures.length; i++) {
    map.removeLayer(identifiedFeatures[i]);
  }
}

function tasmapShowMap(url) {
  window.open(url, '_product');
}

function numberWithCommas(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function titleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
}
